import { createContext } from 'react';

export const SearchManagerContext = createContext({
    onSearch: () => {},
});
